import { inject, Injectable } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class OverviewDrawerService {
  private router = inject(Router);

  public openDrawer() {
    this.router.navigateByUrl(this.getDrawerUrl());
  }

  public getDrawerUrl(): UrlTree {
    return this.router.createUrlTree(['.', { outlets: { drawer: ['dashboard-widgets'] } }]);
  }
}
